import React, { useContext, useEffect, useMemo, useState } from "react";
import PaymentContext from "../../store/PaymentContext";
import { IProductDetailPayment } from "../../@types/IProduct/IProductDetail";
import { PaymentConst, uuidV4 } from "../../utils/payment";
import TableGroup from "./TableGroup";
import { checkIsFullSet } from "./util";
import { getRefreshStockingCount } from "../../pages/api/product";
import moment from "moment";
import { notification } from "antd";
import { error } from "console";

interface IProps {

}
const TableProduct: React.FC<IProps> = ({ }) => {
    const {
        tabActiveStep1,
        rentCarts,
        sellCarts,
        setSellCarts,
        setRentCarts,
        rentCustomer,
        sellCustomer,
        rentAdditionalInformation,
        sellAdditionalInformation,
        isMobile, setSpinLoading
    }: any = useContext(PaymentContext);
    const [api, contextHolder] = notification.useNotification();
    const [isPurchase, setIsPurchase] = useState(false);
    let setCart = Number(tabActiveStep1) === Number(PaymentConst.TabConst.rent) ? setRentCarts : setSellCarts;

    useEffect(() => {
        if (Number(tabActiveStep1) === Number(PaymentConst.TabConst.rent)) {
            setIsPurchase(false)
        } else {
            setIsPurchase(true)
        }
    }, [tabActiveStep1])

    let products: IProductDetailPayment[] = isPurchase ? sellCarts : rentCarts;


    const baseCustomer = isPurchase ? sellCustomer : rentCustomer;
    const additionalInformation = isPurchase ? sellAdditionalInformation : rentAdditionalInformation;

    const getFilterProductFullSet = useMemo(() => {
        let filterProducts: IProductDetailPayment[] = products.filter((pro: IProductDetailPayment) => {

            return checkIsFullSet(pro) && (pro.is_product === true && !pro.is_bundling) ? pro : undefined
        });

        return filterProducts;
    }, [products])
    //console.log('produtcts--TableProduct.tsx', products);

    const renderRowFullSet = () => {
        //console.log("---products,", products?.filter((e: any) => e.accessories.length === 0));

        let filterProducts: IProductDetailPayment[] = products?.filter((pro: IProductDetailPayment) => {
            let filter_attachs = pro.accessories?.filter((acc: any) => acc.bundling_id);
            return pro.accessories?.length === pro?.temp_accessories?.length && pro?.is_product === true && pro?.is_set === false && !pro?.is_bundling && filter_attachs.length < 1
        });
        if (filterProducts.length === 0 && products.length > 0 && products?.filter((e: any) => e.accessories.length === 0).length > 0) {
            filterProducts = products;
        }
        //console.log("---filterProducts,", filterProducts);
        return filterProducts?.length > 0 && (
            <TableGroup
                className={''}
                key={0}
                products={filterProducts}
                is_accessory={false}
                is_purchase={isPurchase}
                parent_item={null}
                carts={products}
                setCarts={setCart}
                baseCustomer={baseCustomer}
                additionalInformation={additionalInformation}
            />
        )
    }

    const renderRowAccessories = () => {
        //console.log('products', products);

        const content: JSX.Element[] = [];

        let filterProducts: IProductDetailPayment[] = products.filter((pro: IProductDetailPayment) => {
            let flag = false;
            pro.temp_accessories?.forEach((acc: any) => {
                let item: any = pro.accessories?.find((_item) => _item.code === acc.code);
                if (item && item.count === acc.count) { flag = true; }
            })

            //Thêm khi là sp phối
            if (pro.is_product === false || pro?.is_bundling === true) {
                flag = true;
            }

            if (
                pro.accessories?.length !== pro?.temp_accessories?.length
                || (pro.temp_accessories?.length > 0 && flag)
            ) {
                return pro;
            }
        });
        let index = -1;

        //console.log("filterProducts", filterProducts);
        //console.log('content----', content);

        for (let item of filterProducts) {
            //console.log("11");

            index++;
            let accessories = item.accessories?.map((acc) => {

                return ({
                    ...acc,
                    qty: item.is_product === false && !acc.bundling_id ? (((item.qty ?? 0) * (acc.product_amount ?? 0))) : acc.qty,
                    is_purchase: item.is_purchase,
                })
            });

            //console.log("accessories", accessories);

            content.push(
                <TableGroup
                    className={
                        index === 1
                            ? (
                                filterProducts?.length > 0 ? 'mt-4' : ''
                            )
                            : 'mt-4'
                    }
                    key={item.id + `${isPurchase == true ? "_sell" : "_rent"}` + "_" + uuidV4()}
                    products={accessories}
                    is_accessory={true}
                    is_purchase={isPurchase}
                    parent_item={item}
                    carts={products}
                    setCarts={setCart}
                    baseCustomer={baseCustomer}
                    additionalInformation={additionalInformation}
                />
            )
        }

        return content;
    }

    async function refreshAmount(setCarts: Function) {
        let carts = await refreshStocking(isPurchase, isPurchase ? sellCarts : rentCarts, setSpinLoading);
        if (carts === null) {
            api.error({
                message: `Thông báo`,
                description: 'Lỗi hệ thống',
                duration: 5,
            });
            return;
        }
        setCarts(carts)
    }


    useEffect(() => {
        refreshAmount(isPurchase ? setSellCarts : setRentCarts)
    }, [tabActiveStep1 === 0, isPurchase])


    return (
        <div>
            <div className={`${isMobile ? 'mb-4' : ''}`}>
                {renderRowFullSet()}
                <div className="">
                    {renderRowAccessories()}
                </div>
            </div>

        </div>
    )
}

export default TableProduct;

export async function refreshStocking(isPurchase: boolean, carts: any, setSpinLoading: Function) {
    try {
        let isError = false;
        setSpinLoading(true);
        //console.log("carts", carts);

        let products = carts;
        //console.log("carts", products);

        //console.log("Innn 55555", products);
        //Row normal
        let rowNormals = products?.filter((pro: any) => {
            let filter_attachs = pro.accessories?.filter((acc: any) => acc.bundling_id);
            return pro.accessories?.length === pro?.temp_accessories?.length && pro?.is_product === true && pro?.is_set === false && !pro?.is_bundling && filter_attachs.length < 1
        });

        //Row accessories
        let rowAccessories = products.filter((pro: any) => {
            let flag = false;
            pro.temp_accessories?.forEach((acc: any) => {
                let item: any = pro.accessories?.find((_item: any) => _item.code === acc.code);
                if (item && item.count === acc.count) { flag = true; }
            })

            //Thêm khi là sp phối
            if (pro.is_product === false || pro?.is_bundling === true) {
                flag = true;
            }

            if (
                pro.accessories?.length !== pro?.temp_accessories?.length
                || (pro.temp_accessories?.length > 0 && flag)
            ) {
                return pro;
            }
        });

        //Row All
        let rowAll = rowNormals.concat(rowAccessories);

        //console.log("rowNormals", rowNormals);
        let sit = 1;
        let datas: any = [];
        let relts: any = [];
        let reltsInCombo: any = {};
        //check for related product
        for (let index = 0; index < rowAccessories.length; index++) {
            const el = rowAccessories[index];

            let relatedProduct = el.accessories?.filter((e: any) => rowNormals?.map((rowN: any) => rowN.code)?.includes(e.code));
            let relatedProductInCombo = index + 1 < rowAccessories.length ? [el, ...el.accessories]?.filter((e: any) => rowAccessories[index + 1].accessories?.map((rowN: any) => rowN.id)?.includes(e.id) && el?.code !== rowAccessories[index + 1]?.code) : [];
            let relatedProductAccessories = el.accessories?.filter((e: any) => rowAccessories?.map((rowN: any) => rowN.code)?.includes(e.code));
            let relatedProductSet = [...rowAccessories]?.filter((e: any) => e.code === el.code && e?.accessories.length === el?.accessories.length) ?? [];

            relts = [
                ...relts,
                ...relatedProduct?.map((e: any) => e.code)
            ];
            //console.log("inn 9999", relatedProduct, relatedProductInCombo, relatedProductAccessories);

            if (relatedProduct && relatedProduct.length > 0) {
                //console.log("inn 9999");

                sit = 0;
                let data: any = {};
                relatedProduct?.map((r: any, indexN: number) => {
                    r.qty = products.find((e: any) => e.code === r.code).qty
                    r.take_date = products.find((e: any) => e.code === r.code).take_date
                    r.return_date = products.find((e: any) => e.code === r.code).return_date;
                    let findR = rowNormals.find((fR: any) => fR.code === r.code);
                    if (!findR) {
                        findR = r
                    }
                    reltsInCombo = {
                        ...reltsInCombo,
                        [r.code]: [
                            ...(reltsInCombo[r.code] ?? []),
                            findR, el
                        ]
                    }
                    rowAll = rowAll.filter((e: any) => e.code !== r.code && e.code !== el.code);

                    return r;
                })
                datas = [
                    ...datas,
                    data
                ];
            }

            //case with combo
            //console.log("relatedProductInCombo", relatedProductInCombo);
            if (relatedProductInCombo && relatedProductInCombo.length > 0) {
                sit = 0;
                relatedProductInCombo?.map((rlp: any) => {
                    reltsInCombo = {
                        ...reltsInCombo,
                        [rlp.code]: [
                            ...(reltsInCombo[rlp.code] ?? [])
                        ]
                    }

                    rowAll = rowAll.filter((e: any) => e.code !== rlp.code);
                    if (!reltsInCombo[rlp.code].find((e: any) => e.code === el.code)) {
                        reltsInCombo = {
                            ...reltsInCombo,
                            [rlp.code]: [
                                ...(reltsInCombo[rlp.code] ?? []),
                                el
                            ]
                        }
                        rowAll = rowAll.filter((e: any) => e.code !== el.code);
                    }

                    if (!reltsInCombo[rlp.code].find((e: any) => e.code === rowAccessories[index + 1].code)) {
                        reltsInCombo = {
                            ...reltsInCombo,
                            [rlp.code]: [
                                ...(reltsInCombo[rlp.code] ?? []),
                                rowAccessories[index + 1]
                            ]
                        }
                        rowAll = rowAll.filter((e: any) => e.code !== rowAccessories[index + 1].code);
                    }
                    return rlp;
                })
            }

            if (relatedProductAccessories && relatedProductAccessories.length > 0) {
                sit = 0;
                let data: any = {};
                relatedProductAccessories?.map((r: any, indexN: number) => {
                    //r.qty = products.find((e: any) => e.id === r.id && e.code === r.code).qty ?? r.qty
                    r.take_date = products.find((e: any) => e.code === r.code).take_date
                    r.return_date = products.find((e: any) => e.code === r.code).return_date;
                    let findR = rowAccessories.find((fR: any) => fR.code === r.code);
                    if (!findR) {
                        findR = r
                    }
                    reltsInCombo = {
                        ...reltsInCombo,
                        [el.code]: [
                            ...(reltsInCombo[r.code] ?? []),
                            el, findR
                        ]
                    }
                    rowAll = rowAll.filter((e: any) => e.code !== r.code && e.code !== el.code);

                    return r;
                })
                datas = [
                    ...datas,
                    data
                ];
            }

            if (relatedProductSet?.length > 0) {
                sit = 0;
                let data: any = {};
                relatedProductSet?.map((r: any) => {
                    r.take_date = products.find((e: any) => e.code === r.code).take_date
                    r.return_date = products.find((e: any) => e.code === r.code).return_date;
                    if (!reltsInCombo[r.code]?.find((e: any) => e.id === r.id)) {
                        reltsInCombo = {
                            ...reltsInCombo,
                            [r.code]: [
                                ...(reltsInCombo[r.code] ?? []),
                                r
                            ]
                        }
                        rowAll = rowAll.filter((e: any) => e.id !== r.id);
                    }


                    return r;
                });

                datas = [
                    ...datas,
                    data
                ];
            }


        }

        //console.log("reltsInCombo", reltsInCombo);
        //console.log("datas", datas);
        //Case 1 no related product
        if (sit === 1) {
            //console.log("In 1", rowAll);
            reltsInCombo = {
                ...reltsInCombo,
                [products[0].code]: [
                    { ...products[0] }
                ]
            };
            rowAll?.map((e: any, index: any) => {
                //console.log("In 23", e);
                e.accessories?.map((acc: any) => {
                    if (acc.checked && acc.bundling_id) {
                        reltsInCombo = {
                            ...reltsInCombo,
                            [acc.code]: [
                                ...(reltsInCombo[acc.code] ?? []),
                                { ...acc }
                            ]
                        };
                    }
                    return acc;
                })


                return e;
            })
            rowAll = rowAll.filter((e: any) => e.code !== products[0].code && e.code);
        }
        //console.log("datas", datas);


        let cloneCarts = [...products];

        let prevCode = null;
        rowAll?.map((e: any) => {
            reltsInCombo = {
                ...reltsInCombo,
                [e.code]: [
                    { ...e }
                ]
            };

            return e;
        })
        //console.log("rowAll", rowAll);
        for (let code in reltsInCombo) {
            let checkedProds: any = [];
            let uniqueReltsInCombo = [...reltsInCombo[code]].filter((v: any, i: any, a: any) => a.findIndex((t: any) => (t.id === v.id && t.name === v.name)) === i);
            //add check product
            if (uniqueReltsInCombo && uniqueReltsInCombo.length > 0) {
                uniqueReltsInCombo?.map((e: any) => {
                    let addParent = false;
                    if (e.checked === true) {
                        checkedProds = [
                            ...checkedProds,
                            e
                        ]
                    } else {
                        //console.log("e.accessories", e.accessories);

                        e.accessories?.map((acc: any) => {
                            if (addParent === false) {
                                if (acc.checked === true) {
                                    addParent = true;
                                    checkedProds = [
                                        ...checkedProds,
                                        e
                                    ]
                                }
                            }
                            return acc;
                        })
                    }
                    return e;
                })
            }

            let slices = checkedProds.slice(1, checkedProds.length);
            //console.log("checkedProds", slices);
            if (!prevCode && checkedProds.length > 0) {
                let take_date = checkedProds[0].take_date ? moment(checkedProds[0].take_date ?? "").format("DD/MM/YYYY HH:mm:ss") : "";
                let return_date = checkedProds[0].return_date ? moment(checkedProds[0].return_date ?? "").format("DD/MM/YYYY HH:mm:ss") : "";
                let related_products = slices?.map((e: any, index: any) => {
                    if (!e.is_product === false) {
                        return {
                            product_code: e.code,
                            index: index + 1,
                            order_id: null,
                            is_mix: !e.is_product,
                            amount: e.qty,
                            from_date: e.take_date ? moment(e.take_date ?? "").format("DD/MM/YYYY HH:mm:ss") : "",
                        }
                    }
                    return {
                        product_code: e.code,
                        index: index + 1,
                        order_id: null,
                        is_mix: !e.is_product,
                        amount: e.qty,
                        from_date: e.take_date ? moment(e.take_date ?? "").format("DD/MM/YYYY HH:mm:ss") : "",
                        product_details: e?.accessories?.map((e: any) => e.code)
                    }
                })
                prevCode = [...checkedProds];
                let product_details = checkedProds[0]?.accessories?.map((e: any) => e.code)?.join(",");
                //console.log("product_details 1.1", checkedProds, product_details);

                //console.log("checkedProds", isPurchase === true ? "" : take_date);
                //console.log("take_date", take_date);
                //console.log("return_date", return_date);
                let res: any = await getRefreshStockingCount(checkedProds[0].code, product_details ?? "", take_date, return_date, !(checkedProds[0].is_product ?? true), checkedProds[0]?.qty, related_products);
                //console.log("res", res);

                if (res) {
                    cloneCarts = [...products]?.map((cart: any) => {
                        //console.log('code', uniqueReltsInCombo[0].code);
                        //console.log('checkedProds', checkedProds);
                        //console.log('cart.code', cart.code);
                        if (checkedProds[0].code === cart.code) {


                            cart.amount = res.in_stock;
                            cart.accessories = cart.accessories?.map((e: any) => {

                                if (res?.accessories[e.code] && typeof res?.accessories[e.code] === 'number') {
                                    //console.log('In 1', e.code);
                                    e.amount = res?.accessories[e.code];
                                }

                                return e;
                            })
                        }
                        cart.accessories = cart.accessories?.map((e: any) => {
                            if (checkedProds[0].code === e.code) {
                                //console.log('In 2', e);
                                e.amount = res.in_stock;
                            }
                            return e;
                        })
                        let findCart = res.related_products?.find((e: any) => e.product_code === cart.code);
                        //console.log("findCart", findCart);
                        if (findCart) {
                            cart.accessories = cart.accessories?.map((e: any) => {
                                //console.log("findCart", findCart?.accessories[e.code], e.code);

                                if (findCart?.accessories[e.code] && typeof findCart?.accessories[e.code] === 'number') {
                                    //console.log("res?.accessories[e.code]", findCart?.accessories[e.code]);

                                    e.amount = findCart?.accessories[e.code];
                                    //console.log("e.amount", e.amount);
                                }
                                return e;
                            })
                            //console.log("cart", cart);
                            cart.amount = findCart.in_stock;
                        }

                        return cart
                    });
                } else {
                    isError = true;
                }

            } else if (prevCode && prevCode.length > 0 && checkedProds.length > 0) {
                let prevCodes = prevCode?.map((e: any) => e.code);
                let reltsInComboReduceCode = checkedProds.filter((e: any) => !prevCodes.includes(e.code));
                if (reltsInComboReduceCode && reltsInComboReduceCode.length > 0) {
                    let take_date = checkedProds[0].take_date ? moment(checkedProds[0].take_date ?? "").format("DD/MM/YYYY HH:mm:ss") : "";
                    let return_date = checkedProds[0].return_date ? moment(checkedProds[0].return_date ?? "").format("DD/MM/YYYY HH:mm:ss") : "";
                    let related_products = checkedProds.slice(1, checkedProds.length)?.map((e: any, index: any) => {
                        if (!e.is_product === false) {
                            return {
                                product_code: e.code,
                                index: index + 1,
                                order_id: null,
                                is_mix: !e.is_product,
                                amount: e.qty,
                                from_date: e.take_date ? moment(e.take_date ?? "").format("DD/MM/YYYY HH:mm:ss") : "",
                            }
                        }
                        return {
                            product_code: e.code,
                            index: index + 1,
                            order_id: null,
                            is_mix: !e.is_product,
                            amount: e.qty,
                            from_date: e.take_date ? moment(e.take_date ?? "").format("DD/MM/YYYY HH:mm:ss") : "",
                            product_details: e?.accessories?.map((e: any) => e.code)
                        }
                    })
                    prevCode = [...checkedProds];
                    //console.log("take_date 1", take_date);
                    //console.log("return_date 1", return_date);
                    let product_details = checkedProds[0]?.accessories?.map((e: any) => e.code)?.join(",");
                    //console.log("product_details 1.2", checkedProds, product_details);
                    let res: any = await getRefreshStockingCount(checkedProds[0].code, product_details ?? "", take_date, return_date, !(checkedProds[0].is_product ?? true), checkedProds[0]?.qty, related_products);
                    if (res) {
                        //console.log('checkedProds', checkedProds);
                        cloneCarts = [...products]?.map((cart: any) => {
                            let findCart = res.related_products?.find((e: any) => e.product_code === cart.code);
                            if (checkedProds[0].code === cart.code) {
                                cart.amount = res.in_stock;
                            }
                            //console.log("findCart", findCart);
                            cart.accessories = cart.accessories?.map((e: any) => {
                                if (checkedProds[0].code === e.code) {
                                    //console.log('In 3', e);
                                    e.amount = res.in_stock;
                                }
                                return e;
                            })
                            if (findCart) {
                                cart.accessories = cart.accessories?.map((e: any) => {
                                    //console.log("findCart", findCart?.accessories[e.code], e.code);

                                    if (findCart?.accessories[e.code] && typeof findCart?.accessories[e.code] === 'number') {
                                        //console.log("res?.accessories[e.code]", findCart?.accessories[e.code]);
                                        //console.log('In 4', e);
                                        e.amount = findCart?.accessories[e.code];
                                        //console.log("e.amount", e.amount);
                                    }
                                    return e;
                                });
                                //console.log("cart", cart);

                                cart.amount = findCart.in_stock;
                            }

                            return cart
                        });

                    } else {
                        isError = true;
                    }

                }
            }

        }
        if (isError) {
            return null
        }
        //console.log("0.1, Result", cloneCarts);
        setSpinLoading(false)
        // if (isSetState) {
        //     setCarts(cloneCarts);
        // }

        return cloneCarts ?? []

    } catch (error) {
        setSpinLoading(false)
        return []
        console.log("err", error);

    }


}
